import React, { useEffect, useState, useMemo } from 'react';
import { Box, ButtonBase, Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { i18n } from '../../../../language';
import { CloseIcon } from '../../../Icon';
import { AutoCompleteSelect } from '../../..';
import AutoCompleteInput from '../../../../components/AutoCompleteInput';
import { systemAPI } from '../../../../apis';
import { userRoleList } from '../../../../utils/userRole';
import { classNames } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '43.75rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2.375rem 1.875rem 1.563rem 1.563rem',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: '#7d86a9',
    marginBottom: '0.625rem',
  },
  main: {
    padding: '0 1.563rem',
    overflow: 'auto',
  },
  // InputBase: {
  //   height: '3.5rem',
  //   borderRadius: '0.625rem',
  //   border: 'solid 1px #e4e7eb',
  //   width: '100%',
  //   paddingLeft: '1.25rem',
  //   marginBottom: '1.875rem',
  //   '& .MuiInputBase-input': {
  //     fontSize: '1rem',
  //     color: '#2e4469',
  //     fontFamily: 'NotoSans-Medium',
  //   },
  // },
  cancelBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    border: 'solid 1.5px #538fff',
    color: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    background: '#f5faff',
  },
  configBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    color: '#fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
  },
  disabledBtn: {
    background: '#c0c6cb',
  },
}));

function SelectWardPop({ closePop, open, confirmClick, loginInfo, userRole }) {
  const classes = useStyles();

  const confirmHandle = () => {
    if (typeof confirmClick === 'function') {
      confirmClick(ValueInputs, sysUserRole);
    }
    closePop();
  };

  const hospitalWardList = useMemo(() => {
    let result = userRoleList.hospWardListDrapformat(userRoleList.filterInActive(userRole));
    return result.map((i) => ({ text: i.hospitalName, value: i.hospitalId }));
  }, [userRole]);

  const [sysRoleList, setSysRoleList] = useState([]);

  const [ValueInputs, setValueInputs] = useState({
    hospId: loginInfo?.hospitalId ?? -1,
    roleId: userRoleList.getRoleId(userRole, loginInfo.userId) ?? -1,
    wardId: loginInfo?.wardId ?? -1,
  });

  const [sysUserRole, setSysUserRole] = useState(null);
  const getSysUserRole = (hospitalId) => {
    try {
      const result = userRoleList.filterHospWardUseHospId(userRoleList.filterInActive(sysRoleList), hospitalId);
      setSysUserRole(result);
      return result;
    } catch (error) {
      console.log('-------------user role 获取失败------------');
    }
    return null;
  };

  useEffect(() => {
    const result = getSysUserRole(ValueInputs.hospId);
    if (Array.isArray(result) && result.length > 0) {
      const newValueInputs = { ...ValueInputs };
      if (ValueInputs.roleId <= -1) {
        newValueInputs.roleId = result?.[0]?.roleId ?? -1;
      }
      if (ValueInputs.wardId <= -1) {
        newValueInputs.wardId = result?.[0]?.wards?.[0]?.wardId ?? -1;
      }
      setValueInputs(newValueInputs);
    }
  }, [sysRoleList, ValueInputs.hospId]);

  useEffect(() => {
    (async () => {
      const { result } = await systemAPI.getSysUserRole({ corpId: loginInfo.corpID });
      setSysRoleList(result);
    })();
  }, []);

  const inputHandle = (type, key) => {
    return (val) => {
      if (type === 'select') {
        if (key === 'hospId') {
          setValueInputs({ ...ValueInputs, [key]: val, wardId: -1, roleId: -1 });
        } else if (key === 'roleId') {
          setValueInputs({ ...ValueInputs, [key]: val, wardId: -1 });
        } else {
          setValueInputs({ ...ValueInputs, [key]: val });
        }
      }
    };
  };

  return (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>{i18n.t('SETTING_SELECT_WARD')}</Typography>
          <IconButton id="select_ward_close_btn" className={classes.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <main className={classes.main}>
          <Box display="flex" mb="1.875rem">
            <Box width="100%">
              <Typography className={classes.label}>{i18n.t('SETTING_HOSPITAL_NAME')}</Typography>
              <AutoCompleteInput
                value={ValueInputs.hospId}
                placeholder={i18n.t('SETTING_HOSPITAL_NAME')}
                itemList={hospitalWardList}
                onChange={inputHandle('select', 'hospId')}
                id="select_ward_popup_hospital"
              />
            </Box>
          </Box>
          <Box display="flex" mb="1.875rem">
            <Box width="50%" mr="1.25rem">
              <Typography className={classes.label}>{i18n.t('SETTING_ROLE')}</Typography>
              <AutoCompleteSelect
                value={ValueInputs.roleId}
                placeholder={i18n.t('SETTING_SELECT_ROLE')}
                itemList={userRoleList.getAllRoleNameFormat(sysUserRole)}
                onChange={inputHandle('select', 'roleId')}
                id="select_ward_popup_role"
              />
            </Box>
            <Box width="50%">
              <Typography className={classes.label}>{i18n.t('SETTING_WARD')}</Typography>
              <AutoCompleteInput
                value={ValueInputs.wardId}
                placeholder={i18n.t('SETTING_SELECT_WARD')}
                itemList={userRoleList.getHospAllWardFormatUseRoleId(sysUserRole, ValueInputs.roleId)}
                onChange={inputHandle('select', 'wardId')}
                id="select_ward_popup_ward"
              />
            </Box>
          </Box>
        </main>
        <Box display="flex" justifyContent="center" style={{ margin: '1.25rem 0 1.875rem 0' }}>
          <ButtonBase
            id="select_ward_cancel_btn"
            className={classes.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('SETTING_CANCEL')}
          </ButtonBase>
          <ButtonBase
            id="select_ward_confirm_btn"
            className={
              !(ValueInputs.roleId > -1 && ValueInputs.wardId > -1)
                ? classNames(classes.configBtn, classes.disabledBtn)
                : classes.configBtn
            }
            onClick={confirmHandle}
            disabled={!(ValueInputs.roleId > -1 && ValueInputs.wardId > -1)}
          >
            {i18n.t('SETTING_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}

export default connect((state) => ({
  loginInfo: state.loginInfo,
  userRole: state.userRole,
}))(SelectWardPop);
